import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ProgressLoaderState } from 'src/app/model/progress-loader-state';

@Injectable({
  providedIn: 'root'
})
export class ProgressLoaderService {
  private loaderSubject = new Subject<ProgressLoaderState>();
  loaderState = this.loaderSubject.asObservable();
  constructor() {}
  show() {
    let state = new ProgressLoaderState();
    state.show = true;
    this.loaderSubject.next(state);
  }
  hide() {
    let state = new ProgressLoaderState();
    state.show = false;
    this.loaderSubject.next(state);
  }
}
